import React, { useEffect, useState, useRef } from 'react'
import classnames from 'classnames'
import { useMapContext } from '../MapContext'
import s from './Copyrights.less'
import { isGE } from '../../Device'
import { uniq } from '../../../utils/array'
import { throttle } from '../../../utils/function'

const DEFAULT_COPYRIGHT = '© Mappy'

const Copyrights = () => {
  const { map } = useMapContext()
  const [copyrights, setCopyrights] = useState(DEFAULT_COPYRIGHT)

  const mapEventAttached = useRef(false)

  useEffect(() => {
    if (!mapEventAttached.current && map) {
      map.on(
        'render',
        throttle(() => setCopyrights(getCopyright()), 300)
      )

      mapEventAttached.current = true
    }
  }, [mapEventAttached, map])

  const getCopyrightsFeatures = () =>
    map
      .queryRenderedFeatures()
      .filter(feature => (feature.layer.id || '').includes('copyrights_') && feature.properties.copyrights)

  const getCopyrights = () =>
    uniq(getCopyrightsFeatures().flatMap(feature => JSON.parse(feature.properties.copyrights)))

  const getCopyright = () => {
    let copyrights = []

    try {
      copyrights = getCopyrights()
    } catch (err) {
      console.error(err)
    }

    return [DEFAULT_COPYRIGHT, ...copyrights].join(' - ')
  }

  return <div className={classnames(s.Copyrights, !isGE() && s.left)}>{copyrights}</div>
}

export default Copyrights
